import { call, put, takeEvery } from 'redux-saga/effects';
import { SendApiRequest } from 'src/api';
import { apiRoutes } from 'src/api/routes';
import {
    fetchCompanies,
    companiesFetched,
    companiesFetchedFailed,
} from '../company';

function* fetchCompaniesEffect() {
    try {
        const response = yield call(SendApiRequest, {
            url: apiRoutes.entities,
            method: 'GET',
            queryParams: {},
        });
        yield put(
            companiesFetched({
                results: response.data,
            }),
        );
    } catch (e) {
        yield put(companiesFetchedFailed());
    }
}

export const companiesSagas = [
    takeEvery(fetchCompanies.type, fetchCompaniesEffect),
];
